
import { Injectable } from '@angular/core';
import { Action, State, StateContext, StateToken, Store } from '@ngxs/store';
import { throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { FUNCTIONS } from 'shared';
// import { ProgramasEstudioService } from '../../../../services/programas-estudio.service';
import { InfoDatosContainerModel, initialState } from '../info-datos.model';
import { InfoDatosBdContainerActions as ContainerActions } from '../info-datos.actions';
import { DatosService } from 'src/app/modules/datos/services/datos.service';
import { produce } from 'immer';
import { APP_STATE_TOKEN, GeneralService, TipoUbigeoEnum } from '@app/core';
export const INFO_DATOS_BD_STATE_TOKEN = new StateToken<InfoDatosContainerModel>('infoDatosBdState');

@State({
    name: INFO_DATOS_BD_STATE_TOKEN,
    defaults: initialState.container
})
@Injectable()
export class InfoDatosBdState {

    constructor(
        private store: Store,
        private datosService: DatosService,
        private generalService: GeneralService,
        // private programasEstudioService: ProgramasEstudioService
    ) {

    }
    @Action(ContainerActions.SetSearchForm)
    setSearchForm(
        { getState, setState }: StateContext<InfoDatosContainerModel>,
        { payload: searchForm }: ContainerActions.SetSearchForm
    ) {
        const state = getState();

        setState({
            ...state,
            searchForm: {
                ...state.searchForm,
                ...searchForm
            }
        });
    }

    listarPaginaBaseDatosBegin = (
        ctx: StateContext<InfoDatosContainerModel>
    ) => {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            loading: true,
            gridInformacionDetallada: {
                ...state.gridInformacionDetallada,
                loading: true
            }
        });
    }

    listarPaginaBaseDatosSuccess = (
        ctx: StateContext<InfoDatosContainerModel>
    ) => (data) => {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            loading: false,
            gridInformacionDetallada: {
                ...state.gridInformacionDetallada,
                loading: false,
                source: {
                    ...state.gridInformacionDetallada.source,
                    items: data.data.map(i => ({
                        ...i,
                        periodo: i.periodo == 'Sin Periodo' ? 'Sin periodo' : i.periodo
                    })),
                    page: data.page,
                    pageSize: data.pageSize,
                    total: data.totalRows
                }
            }
        });
    }

    listarPaginaBaseDatosError = (
        ctx: StateContext<InfoDatosContainerModel>
    ) => (error) => {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            loading: false,
            gridInformacionDetallada: {
                ...state.gridInformacionDetallada,
                loading: false
            }
        });
    }

    @Action(ContainerActions.ListarBaseDatos)
    asyncListarPaginaProgramas(
        ctx: StateContext<InfoDatosContainerModel>,
        { payload }: ContainerActions.ListarBaseDatos
    ) {
        this.listarPaginaBaseDatosBegin(ctx);
        const { gridInformacionDetallada, searchForm } = ctx.getState();

        const pageRequest = payload ? payload : FUNCTIONS.GridRequestFromSource(gridInformacionDetallada.source);

        return this.datosService.listarBaseDatos(
            pageRequest,
            { ...searchForm }
        ).pipe(
            tap(response => {
                this.listarPaginaBaseDatosSuccess(ctx)(
                    {
                        ...response,
                        page: pageRequest.page,
                        pageSize: pageRequest.pageSize
                    }
                );
            }),
            catchError(err => {
                this.listarPaginaBaseDatosError(ctx)(err);
                return throwError(err);
            })
        );
    }

    @Action(ContainerActions.AgregarArchivoDescarga)
    AgregarArchivoDescarga(
        { getState, setState }: StateContext<InfoDatosContainerModel>,
        { payload }: ContainerActions.AgregarArchivoDescarga
    ) {
        setState(produce(getState(), draft => {
            let idArchivos = [];
            draft.archivoDescarga.forEach(x => {
                x.archivos.forEach(y => {
                    idArchivos.push(y.id);
                });
            });
            //existe el mismo archivo
            const foundArchivoIndex = idArchivos.findIndex(
                x => x == payload.item.id
            );
            if (foundArchivoIndex >= 0) {
                return;
            }
            const foundIndex = draft.archivoDescarga.findIndex(
                x => x.tipo == payload.item.tipo && x.periodo == payload.item.periodo
            );
            //existe el mismo tipo y periodo
            if (foundIndex >= 0) {
                draft.archivoDescarga[foundIndex].archivos.push({
                    id: payload.item.id,
                    formato: payload.item.formato
                });
            } else {
                draft.archivoDescarga.push({
                    tipo: payload.item.tipo,
                    periodo: payload.item.periodo,
                    archivos: [{
                        id: payload.item.id,
                        formato: payload.item.formato
                    }]
                });
            }
        }));
    }

    @Action(ContainerActions.EliminarArchivoDescarga)
    EliminarArchivoDescarga(
        { getState, setState }: StateContext<InfoDatosContainerModel>,
        { payload }: ContainerActions.EliminarArchivoDescarga
    ) {
        setState(produce(getState(), draft => {
            const foundIndex = draft.archivoDescarga.findIndex(
                x => x.tipo == payload.item.tipo && x.periodo == payload.item.periodo
            );
            if (foundIndex >= 0) {
                draft.archivoDescarga.splice(foundIndex, 1);
            }
        }));
    }

    @Action(ContainerActions.DescargarZip)
    AsyncDescargarComparacion(
        { getState, setState }: StateContext<InfoDatosContainerModel>,
        { }: ContainerActions.DescargarZip
    ) {
        setState(produce(getState(), draft => {
            draft.loading = true;
        }));
        const { archivoDescarga } = getState();
        let idArchivos = [];
        archivoDescarga.forEach(x => {
            x.archivos.forEach(y => {
                idArchivos.push(y.id);
            });
        });
        return this.datosService.descargarZip(
            idArchivos
        ).subscribe(
            (data: any) => {
                const a = document.createElement('a');
                a.setAttribute('type', 'hidden');
                a.href = URL.createObjectURL(data);
                a.download = "Base de Datos.zip";
                a.click();
                a.remove();
                setState(produce(getState(), draft => {
                    draft.loading = false;
                }));
            },
            catchError(err => {
                setState(produce(getState(), draft => {
                    draft.loading = false;
                }));
                return throwError(err);
            })
        );
    }

    
        @Action(ContainerActions.getObtenerFechaCorte)
           AsyncObtenerFechaCorte(
               { getState, setState }: StateContext<InfoDatosContainerModel>,
               { payload }: ContainerActions.getObtenerFechaCorte
           ) {
        
               return this.generalService.getFechaCorte(payload.modulo).pipe(
                   tap(response => {
                       setState(produce(getState(), draft => {
                           draft.gridFechaCorte = response.data;
                       }));
                   }),
                   catchError(err => {
                       setState(produce(getState(), draft => {
                           draft.gridFechaCorte = null;
                       }));
                       return throwError(err);
                   })
               );
           }
        

    @Action(ContainerActions.getObtenerInstFechaCorte)
  AsyncObtenerInstFechaCort(
    { getState, setState }: StateContext<InfoDatosContainerModel>,
    { payload }: ContainerActions.getObtenerInstFechaCorte
  ) {

    return this.generalService.getFechaCorte(payload.modulo).pipe(
      tap((response) => {
        setState(
          produce(getState(), (draft) => {
              draft.gridInstFechaCorte = response.data;
            
          })
        );
      }),
      catchError((err) => {
        setState(
          produce(getState(), (draft) => {
            draft.gridInstFechaCorte = null;
          })
        );
        return throwError(err);
      })
    );
  }
  
}
